module.exports = __webpack_public_path__ + "img/usuarios.7d202a2b.svg";